import { Node, mergeAttributes } from "@tiptap/core";

import type { Node as ProsemirrorNode } from "@tiptap/pm/model";

export type FileAttachmentNodeAttrs = {
  key: string;
  filename: string | null;
  contentType: string | null;
  byteSize: number | null;
  sourceUid: string | null;
  sourceType: string | null;
};

export function nodeIsFileAttachment(node?: ProsemirrorNode): boolean {
  return node?.type.name === "fileAttachment";
}

export const FileAttachment = Node.create({
  name: "fileAttachment",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      key: {
        default: null,
      },
      filename: {
        default: null,
      },
      contentType: {
        default: null,
      },
      byteSize: {
        default: null,
        parseHTML: (element) => {
          const value = element.getAttribute("bytesize");
          return value ? Number(value) : null;
        },
      },
      sourceUid: {
        default: null,
        parseHTML: (element) =>
          element.getAttribute("sourceuid") ?? element.getAttribute("sourcedocid"),
      },
      sourceType: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "block-file",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["block-file", mergeAttributes(HTMLAttributes)];
  },
});
